import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { isMobile } from "react-device-detect";
import * as Actions from '../../store/actions';
import {
  toggleControlsHover
} from '../../store/actions/controls-visibility-actions';
import * as SwitcherActions from '../../store/actions/mode-switcher-actions';
import { IconButton, ICON_TYPE } from '../../components/font-icons/IconButton'


import {
  getBookType,
  getViewMode,
  getCurrentTheme,
  getGalleryVisibility,
  getControlsVisibility,
  getIsSlideZoomed,
} from '../../store/selectors/selectors';

import AppConfig from '../../AppConfig';
import "./style.scss";

class ModeSwitcher extends Component {

  handleSwitchMode(mode) {
    this.props.switchMode(mode)
  }

  handleMouseEnter = () => {
    if (!isMobile) {
      this.props.toggleControlsHover(true)
    }
  }

  handleMouseLeave = () => {
    if (!isMobile) {
      this.props.toggleControlsHover(false)
    }
  }

  render() {
    const {
      isControlsHidden,
      isGalleryShown,
      currentTheme,
      bookType
    } = this.props;
    const isHidden = isGalleryShown || isControlsHidden;

    const modes = AppConfig.BOOK_TYPE_MODES[bookType];
    return (
      <div
        className={cx(
          'left-sidebar-wrapper',
          {
            currentTheme,
            'left-sidebar-wrapper--is-hidden': isHidden
          }
        )}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="left-sidebar">
          {bookType && modes && modes.length > 1 && modes.map(controlName => (
            <div className="control" key={controlName}>
              <IconButton
                type={ICON_TYPE[`${controlName.toUpperCase()}_MODE`]}
                activeState={this.props.viewMode === controlName}
                onClick={() => this.handleSwitchMode(controlName)}
              />
            </div>
          ))}

        </div>
      </div>
    );
  };

}


const mapStateToProps = state => {
  const isControlsVisible = getControlsVisibility(state)
  const isSlideZoomed = getIsSlideZoomed(state)
  return {
    bookType: getBookType(state),
    viewMode: getViewMode(state),
    isControlsHidden: !isControlsVisible || isSlideZoomed,
    currentTheme: getCurrentTheme(state),
    isGalleryShown: getGalleryVisibility(state)
  }
};

const actionCreators = {
  ...Actions,
  ...SwitcherActions,
  toggleControlsHover
}

export default connect(mapStateToProps, actionCreators)(ModeSwitcher)


// WEBPACK FOOTER //
// ./src/containers/mode-switch/ModeSwitcher.jsx